import { Box, Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  endAdornment?: ReactNode
}
export function Label(props: Props) {
  const { children, endAdornment } = props

  return (
    <Stack direction="row" alignItems="center" spacing={1} height={20}>
      <Typography variant="caption" color="text.secondary">
        {children}
      </Typography>
      <Box display="inline-block">{endAdornment}</Box>
    </Stack>
  )
}
